import React, { Component, useState, useMemo, useEffect } from 'react';

import { fetchData } from "../common/networkRequests";

import './ModalStyle.css';
import { FaArrowDown, FaRegWindowRestore } from "react-icons/fa";

import { getObjectsValue, clearDisplayData, forceClearData, calculateInterest, padding, RelevantIcon, getResultFromCondition, getValueFromCondition, replaceVariablesWithValue, handleLink } from '../oro-module/commonFunctions';
import { ResponsiveBar } from '@nivo/bar'
import moment from "moment";


let colors = ["hsl(85, 70%, 50%)", "hsl(250, 70%, 50%)", "hsl(119, 70%, 50%)", "hsl(353, 70%, 50%)", "hsl(62, 70%, 50%)", "hsl(311, 70%, 50%)", "pink", "green"];


const BarChartCustom = (props) => {

  let [allData, setAllData] = useState([]);
  let [loading, setloading] = useState(false);
  let [columns, setColumns] = useState([]);
  let [indexBy, setIndexBy] = useState("");
  let [xLegend, setxLegend] = useState("");
  let [yLegend, setyLegend] = useState("");

  let { reportName, label_field, axes_labels, legend, column_defs, index_by, aria_label, width } = props.component;
  axes_labels = axes_labels.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
  column_defs = column_defs.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
  // console.log({ axes_labels, column_defs })

  axes_labels = JSON.parse(axes_labels);
  column_defs = JSON.parse(column_defs);


  const setChartData = (response) => {
    let ad = [];
    let cols;

    for (var i = 0; i < response.results.length; i++) {
      cols = [];
      let row = response.results[i];
      let converted = {};
      let chartData = {};
      chartData[index_by] = row[index_by];

      for (var j = 0; j < column_defs.fields.length; j++) {
        let fld = column_defs.fields[j];
        cols.push(fld.name);
        chartData[fld.name] = row[fld.name];
        chartData[fld.name + "Color"] = colors[j];
      }

      ad.push(chartData);
    }

    setAllData(ad);
    setIndexBy(index_by);
    setColumns(cols);

    setxLegend(axes_labels['x'])
    setyLegend(axes_labels['y'])
    setloading(false);

  }

  const getChartData = () => {
    let pd = { gui: "dashboard" };
    if (selectedTourBranch) {
      pd['branch_uid'] = selectedTourBranch.value;
      if (selectedTourBranch.more_1) {
        pd['more_1'] = selectedTourBranch.more_1;
      }
    }
    let saveThis = { dataType: "search", pageData: pd, currentPage: reportName };
    setloading(true);
    fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartData });
  }

  let { selectedTourBranch } = props.parentState.LocalVars;

  let changeWith = false;
  let changed = [];
  if (!changeWith) {
    changed = [selectedTourBranch];
  }

  useEffect(() => getChartData(), changed);


  let block = window.screen.width / 14;
  return (
    <div style={{ height: 300, width: block * 100 }}>
      {!loading &&
        <ResponsiveBar
          data={allData}
          keys={columns}
          indexBy={indexBy}
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={{ scheme: 'nivo' }}
          defs={[
            {
              id: 'dots',
              type: 'patternDots',
              background: 'inherit',
              color: '#38bcb2',
              size: 4,
              padding: 1,
              stagger: true
            },
            {
              id: 'lines',
              type: 'patternLines',
              background: 'inherit',
              color: '#eed312',
              rotation: -45,
              lineWidth: 6,
              spacing: 10
            }
          ]}
          fill={[
            {
              match: {
                id: 'general'
              },
              id: 'dots'
            },
            {
              match: {
                id: 'cheques'
              },
              id: 'lines'
            }
          ]}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: xLegend,
            legendPosition: 'middle',
            legendOffset: 32
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: yLegend,
            legendPosition: 'middle',
            legendOffset: -40
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          legends={[
            {
              dataFrom: 'keys',
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: 'left-to-right',
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          role="application"
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={function (e) { return e.id + ": " + e.formattedValue + " in branch: " + e.indexValue }}
        />
      }
      {loading && <div className="loadingChart">loading . . . </div>}
    </div>
  )
}

export default BarChartCustom; 